<template>
  <section class="demo-offer">
    <div class="container">
      <div class="demo-offer__inner">
        <div class="demo-offer__content">
          <h2 class="demo-offer__title">Что вы получите за 14 дней демо-доступа</h2>
          <ul class="demo-offer__list">
            <li v-for="item in items" :key="item">{{ item }}</li>
          </ul>
          <div class="demo-offer__actions">
            <base-button to="/demo" size="lg" variant="ghost">Получить демо-доступ</base-button>
          </div>
          <p class="demo-offer__note">
            Берём 5 компаний в пилотную программу — внедрение бесплатно.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import BaseButton from '../ui/BaseButton.vue'
export default {
  name: 'DemoOfferSection',
  components: { BaseButton },
  data() {
    return {
      items: [
        'Встреча-разбор (30 минут): как вы считаете премии сейчас',
        'Настроим систему под ваши формулы — за вас',
        'Посчитаем ваш реальный период на ваших данных',
        'Сверим итог с вашим расчётом в Excel — найдём расхождения',
        'Выгрузим ведомость для бухгалтерии',
      ],
    }
  },
}
</script>

<style scoped>
.demo-offer {
  background: linear-gradient(135deg, #1E3A8A 0%, #2563EB 100%);
  padding: 96px 0;
  color: white;
}
.demo-offer__inner {
  max-width: 640px;
  margin: 0 auto;
  text-align: center;
}
.demo-offer__title {
  font-size: 2.25rem;
  font-weight: 800;
  margin-bottom: 36px;
  line-height: 1.2;
}
.demo-offer__list {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 14px;
  text-align: left;
  max-width: 520px;
  margin: 0 auto 36px;
}
.demo-offer__list li {
  font-size: 1.0625rem;
  padding-left: 32px;
  position: relative;
  line-height: 1.5;
}
.demo-offer__list li::before {
  content: '✓';
  position: absolute;
  left: 0;
  font-weight: 700;
  color: #6EE7B7;
  font-size: 1.125rem;
}
.demo-offer__actions {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}
.demo-offer__note {
  font-size: 0.9375rem;
  opacity: 0.8;
}

@media (max-width: 768px) {
  .demo-offer__title { font-size: 1.75rem; }
}
</style>
